export const AUTH_TYPES = {
    ADMIN: 'admin',
    EMPLOYEE: 'employee',
};
